import type { StateCreator } from 'zustand';
import type { Preset } from '@/types';

export interface PresetSlice {
  selectedPreset: Preset | null;
  setSelectedPreset: (preset: Preset | null) => void;
  isPresetLoading: boolean;
  setIsPresetLoading: (loading: boolean) => void;
}

export const presetInitialState = {
  selectedPreset: null as Preset | null,
  isPresetLoading: false,
};

export const createPresetSlice: StateCreator<
  PresetSlice,
  [],
  [],
  PresetSlice
> = (set) => ({
  ...presetInitialState,

  setSelectedPreset: (selectedPreset) => set({ selectedPreset }),
  setIsPresetLoading: (isPresetLoading) => set({ isPresetLoading }),
});
